import { fromJS } from 'immutable';
import { visibleColumns } from './referenceReduxConstants';
import { resolveErrors } from '../../../components/grid/resultGridUtils';

export const REFERENCE_DATA_DELETE_REFERENCE_REQUEST = 'REFERENCE_DATA_DELETE_REFERENCE_REQUEST';
export const REFERENCE_DATA_DELETE_REFERENCE_SUCCESS = 'REFERENCE_DATA_DELETE_REFERENCE_SUCCESS';
export const REFERENCE_DATA_DELETE_REFERENCE_FAILURE = 'REFERENCE_DATA_DELETE_REFERENCE_FAILURE';

export const CLEAR_REFERENCE_DATA = 'CLEAR_REFERENCE_DATA';

export const REFERENCE_DATA_HAVE_REQUEST = 'REFERENCE_DATA_HAVE_REQUEST';
export const REFERENCE_DATA_HAVE_SUCCESS = 'REFERENCE_DATA_HAVE_SUCCESS';
export const REFERENCE_DATA_HAVE_FAILURE = 'REFERENCE_DATA_HAVE_FAILURE';

export const REFERENCE_EARTHQUAKE_DATA_REGION_REQUEST = 'REFERENCE_EARTHQUAKE_DATA_REGION_REQUEST';
export const REFERENCE_EARTHQUAKE_DATA_REGION_SUCCESS = 'REFERENCE_EARTHQUAKE_DATA_REGION_SUCCESS';
export const REFERENCE_EARTHQUAKE_DATA_REGION_FAILURE = 'REFERENCE_EARTHQUAKE_DATA_REGION_FAILURE';

export const REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_REQUEST = 'REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_REQUEST';
export const REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS = 'REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS';
export const REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_FAILURE = 'REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_FAILURE';

export const REFERENCE_TSUNAMI_EVENT_DATA_REGION_REQUEST = 'REFERENCE_TSUNAMI_EVENT_DATA_REGION_REQUEST';
export const REFERENCE_TSUNAMI_EVENT_DATA_REGION_SUCCESS = 'REFERENCE_TSUNAMI_EVENT_DATA_REGION_SUCCESS';
export const REFERENCE_TSUNAMI_EVENT_DATA_REGION_FAILURE = 'REFERENCE_TSUNAMI_EVENT_DATA_REGION_FAILURE';

export const REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_REQUEST = 'REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_REQUEST';
export const REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_SUCCESS = 'REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_SUCCESS';
export const REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_FAILURE = 'REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_FAILURE';

export const REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST = 'REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST';
export const REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS = 'REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS';
export const REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE = 'REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE';

export const REFERENCE_VOLCANO_EVENT_DATA_REGION_FAILURE = 'REFERENCE_VOLCANO_EVENT_DATA_REGION_FAILURE';
export const REFERENCE_VOLCANO_EVENT_DATA_REGION_REQUEST = 'REFERENCE_VOLCANO_EVENT_DATA_REGION_REQUEST';
export const REFERENCE_VOLCANO_EVENT_DATA_REGION_SUCCESS = 'REFERENCE_VOLCANO_EVENT_DATA_REGION_SUCCESS';

export const REFERENCE_VOLCANO_LOCATION_REGION_REQUEST = 'REFERENCE_VOLCANO_LOCATION_REGION_REQUEST';
export const REFERENCE_VOLCANO_LOCATION_REGION_SUCCESS = 'REFERENCE_VOLCANO_LOCATION_REGION_SUCCESS';
export const REFERENCE_VOLCANO_LOCATION_REGION_FAILURE = 'REFERENCE_VOLCANO_LOCATION_REGION_FAILURE';

export const REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_REQUEST = 'REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_REQUEST';
export const REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_SUCCESS = 'REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_SUCCESS';
export const REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_FAILURE = 'REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_FAILURE';

export const REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_REQUEST = 'REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_REQUEST';
export const REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_SUCCESS = 'REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_SUCCESS';
export const REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_FAILURE = 'REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_FAILURE';

export const REFERENCE_RUNUP_DATA_CAUSE_REQUEST = 'REFERENCE_RUNUP_DATA_CAUSE_REQUEST';
export const REFERENCE_RUNUP_DATA_CAUSE_SUCCESS = 'REFERENCE_RUNUP_DATA_CAUSE_SUCCESS';
export const REFERENCE_RUNUP_DATA_CAUSE_FAILURE = 'REFERENCE_RUNUP_DATA_CAUSE_FAILURE';

export const REFERENCE_RUNUP_DATA_MEASURE_TYPE_REQUEST = 'REFERENCE_RUNUP_DATA_MEASURE_TYPE_REQUEST';
export const REFERENCE_RUNUP_DATA_MEASURE_TYPE_SUCCESS = 'REFERENCE_RUNUP_DATA_MEASURE_TYPE_SUCCESS';
export const REFERENCE_RUNUP_DATA_MEASURE_TYPE_FAILURE = 'REFERENCE_RUNUP_DATA_MEASURE_TYPE_FAILURE';

export const REFERENCE_RUNUP_DATA_REGION_REQUEST = 'REFERENCE_RUNUP_DATA_REGION_REQUEST';
export const REFERENCE_RUNUP_DATA_REGION_SUCCESS = 'REFERENCE_RUNUP_DATA_REGION_SUCCESS';
export const REFERENCE_RUNUP_DATA_REGION_FAILURE = 'REFERENCE_RUNUP_DATA_REGION_FAILURE';

export const REFERENCE_RUNUP_DATA_VALIDITY_REQUEST = 'REFERENCE_RUNUP_DATA_VALIDITY_REQUEST';
export const REFERENCE_RUNUP_DATA_VALIDITY_SUCCESS = 'REFERENCE_RUNUP_DATA_VALIDITY_SUCCESS';
export const REFERENCE_RUNUP_DATA_VALIDITY_FAILURE = 'REFERENCE_RUNUP_DATA_VALIDITY_FAILURE';

export const REFERENCE_DATA_TOGGLE_COLUMN = 'REFERENCE_DATA_TOGGLE_COLUMN';

export const REFERENCE_DATA_BULK_EDIT_REQUEST = 'REFERENCE_DATA_BULK_EDIT_REQUEST';
export const REFERENCE_DATA_BULK_EDIT_SUCCESS = 'REFERENCE_DATA_BULK_EDIT_SUCCESS';
export const REFERENCE_DATA_BULK_EDIT_FAILURE = 'REFERENCE_DATA_BULK_EDIT_FAILURE';

export const REFERENCE_EVENT_DATA_SAVE_OPEN_CONFIRMATION = 'REFERENCE_EVENT_DATA_SAVE_OPEN_CONFIRMATION';
export const REFERENCE_EVENT_DATA_SAVE_CANCEL_CONFIRMATION = 'REFERENCE_EVENT_DATA_SAVE_CANCEL_CONFIRMATION';
export const REFERENCE_EVENT_DATA_CANCEL_EDIT = 'REFERENCE_EVENT_DATA_CANCEL_EDIT';
export const REFERENCE_EVENT_DATA_EDIT = 'REFERENCE_EVENT_DATA_EDIT';


const initialState = fromJS({
  deleting: false,
  saving: false,
  formData: {},
  initialFormData: {},
  editConfirmationOpen: false,
  errors: {},
  editing: false,
  initialValues: {},

  fetchedHaves: false,
  haves: [],

  eqFetchedRegions: false,
  eqRegions: [],

  volFetchedRegions: false,
  volRegions: [],

  volLocFetchedRegions: false,
  volLocRegions: [],

  tsuFetchedRegions: false,
  tsuRegions: [],
  tsuFetchedRunupMeasurementTypes: false,
  tsuRunupMeasurementTypes: [],
  tsuFetchedValidities: false,
  tsuValidities: [],
  tsuFetchedCauses: false,
  tsuCauses: [],

  depFetchedPublicationTypes: false,
  depPublicationTypes: [],
  depFetchedGeologicAges: false,
  depGeologicAges: [],

  runupFetchedRegions: false,
  runupRegions: [],
  runupFetchedRunupMeasurementTypes: false,
  runupRunupMeasurementTypes: [],
  runupFetchedValidities: false,
  runupValidities: [],
  runupFetchedCauses: false,
  runupCauses: [],

  visibleColumns,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const referenceDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_REFERENCE_DATA:
      return initialState;

    case REFERENCE_DATA_DELETE_REFERENCE_REQUEST:
      return state.set('deleting', true);
    case REFERENCE_DATA_DELETE_REFERENCE_SUCCESS:
    case REFERENCE_DATA_DELETE_REFERENCE_FAILURE:
      return state.set('deleting', false);


    case REFERENCE_DATA_HAVE_REQUEST:
      return state.merge(fromJS({
        fetchedHaves: false,
      }));
    case REFERENCE_DATA_HAVE_SUCCESS:
      return state.merge(fromJS({
        fetchedHaves: true,
        haves: action.response.items,
      }));
    case REFERENCE_DATA_HAVE_FAILURE:
      return state.merge(fromJS({
        fetchedHaves: true,
      }));

    case REFERENCE_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    // EARTHQUAKE
    case REFERENCE_EARTHQUAKE_DATA_REGION_REQUEST:
      return state.merge(fromJS({
        eqFetchedRegions: false,
      }));
    case REFERENCE_EARTHQUAKE_DATA_REGION_SUCCESS:
      return state.merge(fromJS({
        eqFetchedRegions: true,
        eqRegions: action.response.items,
      }));
    case REFERENCE_EARTHQUAKE_DATA_REGION_FAILURE:
      return state.merge(fromJS({
        eqFetchedRegions: true,
      }));

    // VOLCANO
    case REFERENCE_VOLCANO_EVENT_DATA_REGION_REQUEST:
      return state.merge(fromJS({
        volFetchedRegions: false,
      }));
    case REFERENCE_VOLCANO_EVENT_DATA_REGION_SUCCESS:
      return state.merge(fromJS({
        volFetchedRegions: true,
        volRegions: action.response.items,
      }));
    case REFERENCE_VOLCANO_EVENT_DATA_REGION_FAILURE:
      return state.merge(fromJS({
        volFetchedRegions: true,
      }));

    case REFERENCE_VOLCANO_LOCATION_REGION_REQUEST:
      return state.merge(fromJS({
        volLocFetchedRegions: false,
      }));
    case REFERENCE_VOLCANO_LOCATION_REGION_SUCCESS:
      return state.merge(fromJS({
        volLocFetchedRegions: true,
        volLocRegions: action.response.items,
      }));
    case REFERENCE_VOLCANO_LOCATION_REGION_FAILURE:
      return state.merge(fromJS({
        volLocFetchedRegions: true,
      }));

      // TSUNAMI
    case REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_REQUEST:
      return state.merge(fromJS({
        tsuFetchedValidities: false,
      }));
    case REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedValidities: true,
        tsuValidities: action.response.items,
      }));
    case REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_FAILURE:
      return state.merge(fromJS({
        tsuFetchedValidities: true,
      }));

    case REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_REQUEST:
      return state.merge(fromJS({
        tsuFetchedCauses: false,
      }));
    case REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedCauses: true,
        tsuCauses: action.response.items,
      }));
    case REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_FAILURE:
      return state.merge(fromJS({
        tsuFetchedCauses: true,
      }));

    case REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST:
      return state.merge(fromJS({
        tsuFetchedRunupMeasurementTypes: false,
      }));
    case REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedRunupMeasurementTypes: true,
        tsuRunupMeasurementTypes: action.response.items,
      }));
    case REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE:
      return state.merge(fromJS({
        tsuFetchedRunupMeasurementTypes: true,
      }));

    case REFERENCE_TSUNAMI_EVENT_DATA_REGION_REQUEST:
      return state.merge(fromJS({
        tsuFetchedRegions: false,
      }));
    case REFERENCE_TSUNAMI_EVENT_DATA_REGION_SUCCESS:
      return state.merge(fromJS({
        tsuFetchedRegions: true,
        tsuRegions: action.response.items,
      }));
    case REFERENCE_TSUNAMI_EVENT_DATA_REGION_FAILURE:
      return state.merge(fromJS({
        tsuFetchedRegions: true,
      }));

    // DEPOSIT
    case REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_REQUEST:
      return state.merge(fromJS({
        depFetchedPublicationTypes: false,
      }));
    case REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_SUCCESS:
      return state.merge(fromJS({
        depFetchedPublicationTypes: true,
        depPublicationTypes: action.response.items,
      }));
    case REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_FAILURE:
      return state.merge(fromJS({
        depFetchedPublicationTypes: true,
      }));

    case REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_REQUEST:
      return state.merge(fromJS({
        depFetchedGeologicAges: false,
      }));
    case REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_SUCCESS:
      return state.merge(fromJS({
        depFetchedGeologicAges: true,
        depGeologicAges: action.response.items,
      }));
    case REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_FAILURE:
      return state.merge(fromJS({
        depFetchedGeologicAges: true,
      }));

      // RUNUP
    case REFERENCE_RUNUP_DATA_REGION_REQUEST:
      return state.merge(fromJS({
        runupFetchedRegions: false,
      }));
    case REFERENCE_RUNUP_DATA_REGION_SUCCESS:
      return state.merge(fromJS({
        runupFetchedRegions: true,
        runupRegions: action.response.items,
      }));
    case REFERENCE_RUNUP_DATA_REGION_FAILURE:
      return state.merge(fromJS({
        runupFetchedRegions: true,
      }));

    case REFERENCE_RUNUP_DATA_MEASURE_TYPE_REQUEST:
      return state.merge(fromJS({
        runupFetchedRunupMeasurementTypes: false,
      }));
    case REFERENCE_RUNUP_DATA_MEASURE_TYPE_SUCCESS:
      return state.merge(fromJS({
        runupFetchedRunupMeasurementTypes: true,
        runupRunupMeasurementTypes: action.response.items,
      }));
    case REFERENCE_RUNUP_DATA_MEASURE_TYPE_FAILURE:
      return state.merge(fromJS({
        runupFetchedRunupMeasurementTypes: true,
      }));

    case REFERENCE_RUNUP_DATA_VALIDITY_REQUEST:
      return state.merge(fromJS({
        runupFetchedValidities: false,
      }));
    case REFERENCE_RUNUP_DATA_VALIDITY_SUCCESS:
      return state.merge(fromJS({
        runupFetchedValidities: true,
        runupValidities: action.response.items,
      }));
    case REFERENCE_RUNUP_DATA_VALIDITY_FAILURE:
      return state.merge(fromJS({
        runupFetchedValidities: true,
      }));

    case REFERENCE_RUNUP_DATA_CAUSE_REQUEST:
      return state.merge(fromJS({
        runupFetchedCauses: false,
      }));
    case REFERENCE_RUNUP_DATA_CAUSE_SUCCESS:
      return state.merge(fromJS({
        runupFetchedCauses: true,
        runupCauses: action.response.items,
      }));
    case REFERENCE_RUNUP_DATA_CAUSE_FAILURE:
      return state.merge(fromJS({
        runupFetchedCauses: true,
      }));

    case REFERENCE_EVENT_DATA_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: true,
        initialValues: action.initialValues,
      }));
    case REFERENCE_EVENT_DATA_CANCEL_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: false,
        initialValues: {},
      }));
    case REFERENCE_EVENT_DATA_SAVE_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        initialFormData: action.initialFormData,
        editConfirmationOpen: true,
      }));
    case REFERENCE_EVENT_DATA_SAVE_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        initialFormData: {},
        editConfirmationOpen: false,
      }));
    case REFERENCE_DATA_BULK_EDIT_REQUEST:
      return state.merge(fromJS({
        saving: true,
        errors: {},
      }));
    case REFERENCE_DATA_BULK_EDIT_SUCCESS:
      return state.merge(fromJS({
        saving: false,
        errors: {},
      }));
    case REFERENCE_DATA_BULK_EDIT_FAILURE:
      return state.merge(fromJS({
        saving: false,
        errors: resolveErrors(action.response),
      }));
    default:
      return state;
  }
};
